import { DropZone } from '../types';

interface Point {
  x: number;
  y: number;
}

/**
 * Determine which drop zone the pointer is over based on its position within a panel.
 * Determines the nearest edge (top/bottom/left/right) based on pointer position.
 */
export function getDropZone(rect: DOMRect, point: Point): DropZone {
  const relX = (point.x - rect.left) / rect.width;
  const relY = (point.y - rect.top) / rect.height;

  // Determine nearest edge based on minimum distance
  const distTop = relY;
  const distBottom = 1 - relY;
  const distLeft = relX;
  const distRight = 1 - relX;

  const minDist = Math.min(distTop, distBottom, distLeft, distRight);

  if (minDist === distTop) {
    return 'top';
  }
  if (minDist === distBottom) {
    return 'bottom';
  }
  if (minDist === distLeft) {
    return 'left';
  }
  return 'right';
}

/**
 * Detect canvas-level drop zones (top/bottom edges of entire canvas)
 */
export function getCanvasDropZone(canvasRect: DOMRect, point: Point, hasContent: boolean): DropZone | null {
  if (!hasContent) {
    // Empty canvas - any drop creates first row
    return 'top';
  }

  const relY = (point.y - canvasRect.top) / canvasRect.height;

  // Top 10% of canvas - new row at top
  if (relY < 0.1) {
    return 'top';
  }

  // Bottom 10% of canvas - new row at bottom
  if (relY > 0.9) {
    return 'bottom';
  }

  // Not in canvas edge zone
  return null;
}
